import script from "./esTaskSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./esTaskSettings.vue?vue&type=script&lang=ts&setup=true"

import "./esTaskSettings.vue?vue&type=style&index=0&id=a83832e4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a83832e4"]])

export default __exports__